import React                   from 'react'
import { connect }             from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import i18n from '../../../i18n';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from '../../forms/DatePicker'
import Formsy from 'formsy-react';
import Input from '../../forms/services/Input';
import CheckBox from '../../forms/services/CheckBox'
import Radio from '../../forms/services/Radio'
import Table from '../../forms/services/Table'
import withBaseComponent from '../../withBaseComponent'
import ReactHtmlParser from "html-react-parser"

class ResumeSuspended extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this)
    let { aggregation_start_date } = this.props.account
    this.state = {
      hasSpecifyDate: typeof aggregation_start_date !== "undefined"
    }
  }

  filter(model) {
    model["credentials"] = model["credentials"].filter(item => {
      if(item && item.alphameric !== undefined && item.alphameric.trim() === '') {
        return false;
      }

      if(item && item.password !== undefined && item.password.trim() === '') {
        return false;
      }

      return true;
    })

    return model
  }

  onSubmit(model) {
    if (this.hasError())
      return

    const {id} = this.props.account

    if (model["credentials"]) {
      model["credentials"] = Object.values(model["credentials"])
      model = this.filter(model)
    }

    this.props.accountActions.accountResumeSuspend(id, model).then(() => {
      this.props.accountActions.accountShow(id).then(() => {
        this.props.toggle && this.props.toggle()
        this.props.onResumeSuspended()
      })
    })
  }

  specifyDate(e) {
    this.setState({hasSpecifyDate: "true" === e.target.value })
  }

  render_field(item) {
    let opts = {
      item: item,
      form: this.refs.form,
      className: "form-group col-md-12"
    }

    if (!item.is_optional && item.input_type !== "checkbox")
      opts = Object.assign({}, opts, { required: true })
    switch(item.input_type) {
      case "checkbox":
        return <CheckBox key={item.id} name={`credentials[${item.type}]`} type="checkbox" {...opts} />
      case "radio":
        opts["required"] = false
        opts['defaultValue'] = {radio: item.format.radio[0]}
        return <Radio key={item.id} name={`credentials[${item.type}]`} {...opts} />
      case "table":
        return <Table name={`credentials[${item.type}]`} {...opts} />
      case "password":
        return <Input key={item.id} name={`credentials[${item.type}]`} type='password' {...opts} />
      default:
        return <Input key={item.id} name={`credentials[${item.type}]`} type='text' {...opts} />
    }
  }

  displayName() {
    const { display_name, service } = this.props.account

    return display_name || (service && service.name)
  }

  render() {
    let items = []
    const { service, aggregation_start_date } = this.props.account
    items = service.forms.filter(field => field.is_displayable)
    return (
      <Modal isOpen={this.props.isOpen} className={`mfc-modal-normal bank-modal bank-edit-login ${this.state.hasSpecifyDate ? 'has-specify-date' : ''}`} centered={true}>
        <Formsy ref="form" onInvalidSubmit={this.showErrors} onSubmit={this.onSubmit} onValid={this.enableButton} onInvalid={this.disableButton}>
        <ModalHeader toggle={this.props.toggle}>{i18n.t('bank.resume_suspended_title', {name: this.displayName()})}</ModalHeader>
        <ModalBody>
          <div className="row no-gutters mfc-new-bank-desc">
            <div className="col-sm-12 info-service ">
              <p>金融機関登録前のご注意事項</p>
              <p className="small-desc">
                {service && ReactHtmlParser(service.description)}
              </p>
              {service && service.login_url && <a target="_blank" href={service.login_url} rel="noopener noreferrer"><i
                className="fas fa-external-link-alt"></i> {`${service.name}のサイトでログインに用いる情報を確認する`}</a>}
            </div>
            <div className="w100">
              <div className="form-row">
                {items.map(item => this.render_field(item))}
              </div>
              <div className="form-row checkbox-form">
                <label className=" ">{i18n.t('bank.get_data_date')}</label>
                <div className="form-group">
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="is_specify_date" id="no_date" defaultChecked={!this.state.hasSpecifyDate} value={false} onChange={(e) => this.specifyDate(e)} />
                    <label className="form-check-label" htmlFor="no_date">
                      {i18n.t('bank.no_date')}
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name="is_specify_date" id="specify_date" defaultChecked={this.state.hasSpecifyDate} value={true} onChange={(e) => this.specifyDate(e)}/>
                    <label className="form-check-label" htmlFor="specify_date">
                      {i18n.t('bank.after_specify_date')}
                    </label>
                  </div>
                </div>
              </div>

              {this.state.hasSpecifyDate && <div className="form-row">
                <label className="col-sm-12">{i18n.t('bank.md_newbank.body.select_date')}</label>
                <div className="col-sm-12 form-group mfc-box-calendar">
                  <DatePicker
                    name="aggregation_start_date"
                    required validations="minLength:10"
                    validationError="This value must is date"
                    startDate={aggregation_start_date}
                    dateFormat={"yyyy/MM/dd"}/>
                </div>
              </div>}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
          <button className="btn mfc-btn-blue medium" type="submit">
            {i18n.t('common.save')}
          </button>
        </ModalFooter>
      </Formsy>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    userEmail: state.user.get('email')
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResumeSuspended)
